import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
// from flaticon
const digital = (props) => {
  return (
    <span class={`${props.masterClasses || ''}`} title={props.title || ''} style={'user-select:none;'}>
      <svg class={props.classes || ""} onclick={(e) => props.action && props.action(e)} xmlns="http://www.w3.org/2000/svg" width={props.width || "512pt"} height={props.height || "512pt"} viewBox="0 -960 960 960" fill="#fff">
        <path d="M120-120v-200h160l160-160v-128q-36-13-58-43.5T360-720q0-50 35-85t85-35q50 0 85 35t35 85q0 38-22 68.5T520-608v128l160 160h160v200H640v-122L480-402 320-242v122H120Z"/>
      </svg>
    </span>
  );
};





export default digital;
